export const CONVERSATIONS_PER_PAGE = 25;

export const wrapTablesForScroll = (html: string): string =>
  html.replace(/<table/g, '<div class="ai-table-scroll"><table').replace(/<\/table>/g, '</table></div>');
export const CONVERSATION_MAX_TITLE_LENGTH = 100;

export type ConversationListItem = {
  id: string;
  title: string;
  lastUserMessageAt?: string | null;
};
